import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setRepoTemplate } from "./api";
import type {
  RepoBranchTemplateResponse,
  SetBranchTemplateRequest,
} from "./api";

interface SetRepoTemplateVars {
  readonly repoFullName: string;
  readonly body: SetBranchTemplateRequest;
}

// PUT per-repo override. На успех инвалидируем repo-запрос этого
// репозитория — секция перерисуется с новым override.
export function useSetRepoTemplate(): ReturnType<
  typeof useMutation<RepoBranchTemplateResponse, Error, SetRepoTemplateVars>
> {
  const queryClient = useQueryClient();
  return useMutation<RepoBranchTemplateResponse, Error, SetRepoTemplateVars>({
    mutationFn: (vars) => setRepoTemplate(vars.repoFullName, vars.body),
    onSuccess: (_data, vars) => {
      void queryClient.invalidateQueries({
        queryKey: ["branchNameTemplate", "repo", vars.repoFullName],
      });
    },
  });
}
